import MolGrid from "../../components/Grid/MolGrid";
import { CommitteApprovalListTableConfig } from "./data/CommitteeApprovalListTableConfig";
import { useRef } from "react";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { useState } from "react";
import AddCommitteeApprovalForm from "./component/AddCommitteeApprovalForm";
import { useEffect } from "react";
import { useAddEditCommitteApprovalMutation, useDeleteCommitteApprovalMemberByIdMutation, useGetAllCommitteApprovalListMutation } from "../../app/services/CommitteeApprovalManagement/CommitteApprovalManagementApi";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";
import EditCommitteApprovalForm from "./component/EditCommitteeApprovalForm";
import { encryptAESID } from "../../utils/Encryption";

const CommitteApprovalList = () => {
    const committeeApprovalRef = useRef();
    const addMemberFormRef = useRef();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState();
    const [dataSource, setDataSource] = useState();
    const { confirm, success, error } = SwalAlert();
    const [paginationRequest, setPaginationRequest] = useState({
        pageNo: 1,
        pageSize: 20,
    });

    const [getAllCommitteeApproval, { isSuccess: isgetAllCommitteeApproval, isLoading: isLoadingCommitteeApproval, data: getAllCommitteeApprovalDataResponse },] = useGetAllCommitteApprovalListMutation();
    const [deleteCommitteeApprovalMemberById, { isLoading: isDeleteMemberLoading, isSuccess: isDeleteMemberSuccess, data: deleteMemberResponse }] = useDeleteCommitteApprovalMemberByIdMutation();
    const [addEditCommitteApprovalMember, { isLoading: isAddMemberLoading, isSuccess: isAddMemberSuccess, data: addMemberResponse }] = useAddEditCommitteApprovalMutation();

    useEffect(() => {
        getAllCommitteeApproval(paginationRequest)
    }, [])

    useEffect(() => {
        if (!isLoadingCommitteeApproval && isgetAllCommitteeApproval && getAllCommitteeApprovalDataResponse) {
            setPaginationRequest(prev => ({ ...prev, totalCount: getAllCommitteeApprovalDataResponse.totalCount }));
            setDataSource(getAllCommitteeApprovalDataResponse?.itemList);
        }
    }, [isLoadingCommitteeApproval, isgetAllCommitteeApproval, getAllCommitteeApprovalDataResponse]);

    useEffect(() => {
        if (!isDeleteMemberLoading && isDeleteMemberSuccess && deleteMemberResponse) {
            if (!deleteMemberResponse.hasError) {
                success("Record Deleted Successfully.");
                getAllCommitteeApproval(paginationRequest);
            } else {
                error(deleteMemberResponse.errorMessage);
            }
        }
    }, [isDeleteMemberLoading, isDeleteMemberSuccess, deleteMemberResponse]);

    useEffect(() => {
        if (!isAddMemberLoading && isAddMemberSuccess && addMemberResponse) {
            if (!addMemberResponse.hasError) {
                success("Record has been added successfully.");
                setIsModalOpen(false);
                getAllCommitteeApproval(paginationRequest);
            } else {
                error(addMemberResponse.errorMessage);
            }
        }
    }, [isAddMemberLoading, isAddMemberSuccess, addMemberResponse]);

    const handlePageChange = ({ pageNumber, pageSize }) => {
        const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
        setPaginationRequest(updatedPaginationRequest);
        getAllCommitteeApproval(updatedPaginationRequest);
    };
    const handleSaveMember = () => {
        const formData = addMemberFormRef.current?.getFormData();
        if (!formData) return;

        if (formData.password === formData.confirmPassword) {
            const request = {
                Name: formData?.name,
                Email: formData?.emailAddress,
                Password: formData?.password
            };
            addEditCommitteApprovalMember(request);
        } else {
            ToastService.error('Password and Confirm Password Not Match');
        }
    };

    const handleDelete = (data) => {
        confirm('Delete?', 'Are you sure you want to Delete?', 'Delete', 'Cancel').then((confirmed) => {
            if (confirmed) {
                const request = { id: data.adminID };
                deleteCommitteeApprovalMemberById(request);
            }
        });
    };

    const openModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const editOpenModel = () => {
        setIsEditModalOpen(!isEditModalOpen);
        getAllCommitteeApproval(paginationRequest)
    }

    const handleEdit = (data) => {
        setSelectedId(data.adminID)
        setIsEditModalOpen(!isEditModalOpen)
    }

    const actionHandler = {
        DELETE: handleDelete,
        EDIT: handleEdit
    };

    return (<>
        <div>
            <div className="membership-application">
                <div className="form-section">
                    <div className="row">
                        <div className="col-lg-12 btn-sec mt-2 mb-3">
                            <Buttons
                                buttonText="Add Member"
                                buttonTypeClassName="btn success-btn ml-auto mr-0"
                                onClick={openModal}
                            />
                        </div>
                    </div>
                </div>
                <div className="mt-4">
                    <MolGrid
                        ref={committeeApprovalRef}
                        configuration={CommitteApprovalListTableConfig}
                        dataSource={dataSource}
                        allowPagination={true}
                        isLoading={isLoadingCommitteeApproval}
                        pagination={paginationRequest}
                        onPageChange={handlePageChange}
                        onActionChange={actionHandler}
                    />
                </div>


            </div>

            {/* Add Member Modal */}
            {isModalOpen &&
                <CenterModel
                    modelTitle={'Add member'}
                    show={"test"}
                    handleClose={openModal}
                    onUpload={openModal}
                >
                    <AddCommitteeApprovalForm
                        ref={addMemberFormRef}
                        handleSaveMember={handleSaveMember}
                        isLoading={isAddMemberLoading} />
                </CenterModel>
            }

            {/* Edit Member Modal */}
            {isEditModalOpen &&
                <CenterModel
                    modelTitle={'Edit member'}
                    show={"test"}
                    handleClose={editOpenModel}
                    onUpload={editOpenModel}
                >
                    <EditCommitteApprovalForm selectedId={encryptAESID(selectedId)} />
                </CenterModel>
            }
        </div>
    </>)
}
export default CommitteApprovalList;